// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"2e9733e8","219":"f9e06779"}[chunkId] + ".chunk.css";
};